// extracted by mini-css-extract-plugin
export default {"CheckOutlined":"styles_CheckOutlined__z5dOJ"};